import FlyToDay from '@/views/FlyToDay/index.vue'

const FlyToDayRouter = {
  path: '/fly-to-day',
  name: 'FlyToDay',
  component: FlyToDay,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default FlyToDayRouter
